import React, { FunctionComponent } from 'react'

export type RouteModalItemProps = {
  children?: React.ReactNode
}

const RouteModalItem: FunctionComponent<RouteModalItemProps> = ({ children }) => <li className="flex">{children}</li>

export default RouteModalItem
